import React from 'react';
import OrganizationOnboardingStep from './OrganizationOnboardingStep';
import * as styles from './OrganizationOnboardingStepTeam.module.scss';
import { SessionActions } from '../../account/sessionSlice';
import redirectToHost from '../../admin/appearance/redirectToHost';
import splitSubdomain from '../../admin/appearance/splitSubdomain';
import TeamIconEditor from '../../admin/appearance/TeamIconEditor';
import useUpdateOrganization from '../../admin/appearance/useUpdateOrganization';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import { Field } from '../../components/Form';
import { SUBJECT_ORG_ONBOARDING } from '../../constants/onboarding';
import { getUrlWithOnboardingQueries } from '../onboardingQueryString';

type Values = { name: string; subdomain: string };

interface OrganizationOnboardingStepTeamProps {
  lastStep: boolean;
  step: number;
  onSkip: () => void;
  onNext: () => void;
  onPrevious: (() => void) | null;
}

const OrganizationOnboardingStepTeam = ({
  step,
  ...props
}: OrganizationOnboardingStepTeamProps) => {
  const organization = useAppSelector((state) => state.session.organization);
  const dispatch = useAppDispatch();
  const updateOrganization = useUpdateOrganization({ host: organization.host });

  const handleSubmit = async (values: Values) => {
    const { data } = await updateOrganization(values);

    if (
      data?.organization?.host &&
      data?.organization?.host !== document.location.host
    ) {
      redirectToHost(
        data.organization.host,
        () => {
          dispatch(SessionActions.clearSession());
        },
        getUrlWithOnboardingQueries(SUBJECT_ORG_ONBOARDING, step + 1),
      );

      // Return a forever wait to prevent the next step from showing before redirecting
      await new Promise(() => {});
    }
  };

  const [subdomain, baseDomain] = splitSubdomain(organization.host);

  return (
    <OrganizationOnboardingStep<Values>
      {...props}
      initialValues={{ name: organization.name, subdomain }}
      title="Customize your team"
      subtitle="Enter your team details to reserve a URL"
      onSubmit={handleSubmit}
    >
      <div className={styles.logoEditorContainer}>
        <TeamIconEditor size="large" />
      </div>
      <Field label="Team name" name="name" required />
      <Field
        append={baseDomain}
        label="Subdomain"
        name="subdomain"
        helpText="You can add a custom domain later"
        required
      />
    </OrganizationOnboardingStep>
  );
};

export default OrganizationOnboardingStepTeam;
